




















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import dayjs from 'dayjs';

@Component
export default class FormItem extends Vue {

  @Prop({default: ''}) readonly value!: string;
  @Prop({required: true}) fieldName!: string;
  @Prop() placeholder?: string;
  @Prop() type?: string;

  onValueChanged(value: string) {
    this.$emit('update:value', value);
  }

  dateReformat(isoString: string) {
    if (dayjs(isoString).isAfter(dayjs())) {
      window.alert('难道你能预知未来？');
      return dayjs().format('YYYY-MM-DD');
    }
    return dayjs(isoString).format('YYYY-MM-DD');
  }
}
